const api = {
    bossLogin: 'acc/pxb/login.shtml',
    bossLogout: 'acc/logout.shtml',
    parentLogin: 'acc/parent/login.shtml', //伪登录接口
    bpFileSign: 'pxb/bp/file/sign.shtml',
    editMaterial: 'pxb/ad/edit/material.shtml', // 上传素材

    // 找回密码
    userSendCode: 'acc/user/sendCode.shtm', // 发送验证码
    userAuthCode: 'acc/user/authCode.shtm', // 校验验证码
    userRetrievePwd: 'acc/user/retrievePwd.shtm', // 找回密码

    campaignChart: 'bp/home/campaignChart.shtml',//首页报表

    //公共
    deviceTypeList: 'pxb/common/deviceType/page.shtml', //设备类型
    // fileSign: 'pxb/bss/file/sign.shtml', //文件签名
    fileSign: 'pxb/bp/file/sign.shtml', //文件签名
    sizeList: 'pxb/common/size/listBy.shtml',//按设备类型查规格
    sceneList: 'pxb/bss/scene/listOptions.shtml', //场景列表
    sceneListAll: 'pxb/bss/scene/listAll.shtml', //场景二级菜单
    districtList: 'pxb/common/district/list.shtml', //地域下拉
    regionArea: 'pxb/common/district/listArea.shtml',
    balance: 'bp/pay/balance.shtml', //首页金额统计
    sizeAllList: 'pxb/common/size/list.shtml', // 下拉规格
    commonOptionMenu: 'pxb/common/option/menu.shtml', // 公共下拉列表

    //推广计划
    campaignPage: 'bp/campaign/page.shtml', //推广计划分页
    campaignList: 'bp/campaign/list.shtml', //推广计划列表
    campaignDetail: 'bp/campaign/find.shtml', //推广计划详情
    campaignExist: 'bp/campaign/exist.shtml', //推广计划检查存在
    campaignSave: 'bp/campaign/save.shtml', //推广计划新增
    campaignUpdate: 'bp/campaign/update.shtml', //推广计划更新
    campaignDelete: 'bp/campaign/delete.shtml', //推广计划删除
    campaignEnable: 'bp/campaign/enable.shtml', //推广计划启用
    campaignDisable: 'bp/campaign/disable.shtml',//推广计划暂停
    campaignEnableBatch: 'bp/campaign/enable/batch.shtml', //推广计划批量启用
    campaignDisableBatch: 'bp/campaign/disable/batch.shtml', //推广计划批量暂停

    //推广组
    adgroupList: 'bp/adgroup/list.shtml', //推广组列表
    adgroupPage: 'bp/adgroup/page.shtml', //推广组分页
    adgroupDetail: 'bp/adgroup/find.shtml', //推广组详情
    adgroupExist: 'bp/adgroup/exist.shtml', //推广组检查存在
    adgroupSave: 'bp/adgroup/save.shtml', //推广组新增
    adgroupUpdate: 'bp/adgroup/update.shtml', //推广组更新
    adgroupUpdateDaySum: 'bp/adgroup/update/daySum.shtml',
    adgroupEnable: 'bp/adgroup/enable.shtml', //推广组启用
    adgroupDisable: 'bp/adgroup/disable.shtml', //推广组暂停
    adgroupDelete: 'bp/adgroup/delete.shtml', //推广组删除
    adgroupDisableBatch: 'bp/adgroup/disable/batch.shtml', //推广组批量暂停
    adgroupEnableBatch: 'bp/adgroup/enable/batch.shtml', //推广组批量启用

    //广告
    adInfoList: 'bp/adInfo/list.shtml', //广告列表
    adInfoPage: 'bp/adInfo/page.shtml', //广告分页
    adInfoDetail: 'yxb/ad/one.shtml', //广告详情
    adInfoExist: 'bp/adInfo/exist.shtml', //广告是否存在
    adInfoSave: 'yxb/ad/add.shtml', //广告新增
    adInfoUpdate: 'yxb/ad/edit.shtml', //广告更新
    adInfoDisable: 'bp/adInfo/disable.shtml', //广告暂停
    adInfoEnable: 'bp/adInfo/enable.shtml', //广告启用
    adInfoDelete: 'bp/adInfo/delete.shtml', //广告删除
    setCheckUrl: 'bp/adInfo/setCheckUrl.shtml', //设置监播
    adInfoDisableBatch: 'bp/adInfo/disable/batch.shtml',
    adInfoEnableBatch: 'bp/adInfo/enable/batch.shtml',

    //用户群
    customerList:'bp/customer/list.shtml', //用户群列表
    customerPage:'bp/customer/page.shtml', //用户群分页
    customerSave:'yxb/customer/mini/app/add.shtml',//用户群新增
    customerFind:'yxb/customer/mini/app/one.shtml',//用户群单条详情
    customerUpdate:'yxb/customer/mini/app/edit.shtml', //用户群更新
    customerDelete:'bp/customer/delete.shtml', //用户群删除
    customerExcel: 'pxb/bp/file/sign/excel.shtml',
    customerDevCntParams:'bp/customer/devCnt/params.shtml',//按地域&场景取设备类型下点位数
    customerDevCntMap: 'bp/customer/devCnt/map.shtml', //按地图数据&场景取设备类型下点位数
    customerDevCntNewMap: 'bp/customer/devCnt/new/map.shtml', //用户群管理-地图筛选点位查询
    customerDevNewMapDetail: 'bp/customer/devCnt/new/map/detail.shtml',
    customerExist: 'bp/customer/exist.shtml', //用户群是否存在
    customerDevs: '/bp/customer/devs.shtml', //用户群关联点位
    customerDevsExcel: '/bp/customer/devs/excel.shtml', //用户群关联点位表导出
    customerV2Save: 'bp/customer/v2/save.shtml', // 上传excel添加用户群
    customerMpCategory: 'yxb/customer/mini/app/category.shtml', // 小程序服务类目下拉列表
    customerMpProfession: 'yxb/customer/mini/app/profession.shtml', // app行业分类下拉列表
    customerMpMap: 'yxb/customer/mini/app/map.shtml', // 匹配小程序
    customerGroups: 'yxb/customer/mini/app/option.shtml', // 用户群下拉列表
    customerAppList: 'yxb/customer/mini/app/list.shtml', // 应用下拉列表

    //报表
    campaignReport: 'bp/report/campaign.shtml', //报表 推广计划
    adgroupReport: 'bp/report/adgroup.shtml', //报表 推广组
    adInfoReport: 'bp/report/adinfo.shtml', //报表 广告
    campaignReportPerday: 'bp/report/campaign/perday.shtml', //报表 推广计划 每天
    campaignReportPerhour: 'bp/report/campaign/perhour.shtml', //报表 推广计划 每小时
    adgroupReportPerday: 'bp/report/adgroup/perday.shtml', //报表 推广组 每天
    adgroupReportPerhour: 'bp/report/adgroup/perhour.shtml', //报表 推广组 每小时
    adinfoReportPerday: 'bp/report/adinfo/perday.shtml',//报表 广告 每天
    adinfoReportPerhour: 'bp/report/adinfo/perhour.shtml',//报表 广告 每小时
    bpReportList: 'bp/report/list.shtml', // 维度报表
    bpReportExport: 'bp/report/export.shtml', // 下载-维度报表
    bpReportListday: 'bp/report/listday.shtml', // 按天报表
    bpReportExportday: 'bp/report/exportday.shtml', // 下载-按天报表
    bpReportListHour: 'bp/report/listhour.shtml', // 小时报表
    bpReportRxportHour: 'bp/report/exporthour.shtml', // 下载-小时报表

    //套餐
    comboExcel: 'bp/combo/devs/excel.shtml', //套餐点位导出
    comboDevs: 'bp/combo/devs.shtml', //套餐点位表
    comboFind: 'bp/combo/find.shtml', //套餐单条详情
    comboPush: 'bp/combo/push.shtml', //套餐推荐
    comboPage: 'bp/combo/page.shtml', //套餐列表

    //报表下载
    excelCampaign: 'bp/report/campaign/excel.shtml',
    excelAdgroup: 'bp/report/adgroup/excel.shtml',
    excelAdInfo: 'bp/report/adinfo/excel.shtml',
    excelCampaignDay: 'bp/report/campaign/perday/excel.shtml',
    excelAdgroupDay: 'bp/report/adgroup/perday/excel.shtml',
    excelAdInfoDay: 'bp/report/adinfo/perday/excel.shtml',
    excelCampaignHour: 'bp/report/campaign/perhour/excel.shtml',
    excelAdgroupHour: 'bp/report/adgroup/perhour/excel.shtml',
    excelAdInfoHour: 'bp/report/adinfo/perhour/excel.shtml',

    //充值
    recharge: 'bp/pay/recharge/weixin.shtml',
    rechargeStatus: 'bp/pay/status.shtml',

    //账户
    expense: 'bp/expense/page.shtml',
    logs:'bp/logs/page.shtml',
    logsTypeList: 'bp/logs/type/list.shtml', //操作类型
    logsUserList: 'bp/logs/user/list.shtml'
}

export default api



// WEBPACK FOOTER //
// ./src/api/index.js